import { type PropsWithChildren, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { type RichTextEditorConfig, RichTextEditorContext } from './RichTextEditorContext';

const PreviewTranslation = () => {
  const { t } = useTranslation();
  const { translations } = useContext(RichTextEditorContext);

  useEffect(() => {
    document.documentElement.style.setProperty('--rte-text-preview', `"${t(translations.preview)}"`);
  }, [t, translations.preview]);

  return null;
};

export const RichTextEditorProvider = ({ children, value }: PropsWithChildren<{ value: RichTextEditorConfig }>) => (
  <RichTextEditorContext.Provider value={value}>
    <PreviewTranslation />
    {children}
  </RichTextEditorContext.Provider>
);
